import { Helmet } from 'react-helmet';
import { Box, Grid } from '@mui/material';
import StoreProductSales from 'components/Sales/StoreProductSales';
import ProductFilterForm from 'components/product/ProductFilterForm';
import { useState } from 'react';

const ProductList = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const sendDataToParent = (sDate, eDate) => {
    setStartDate(sDate);
    setEndDate(eDate);
  };

  return (
    <>
      <Helmet>
        <title> Product sales | Nutriart</title>
      </Helmet>
      <Box pt={2}>
        <Grid item lg={12} md={12} xl={12} xs={12}>
          <ProductFilterForm sendDataToParent={sendDataToParent} />
        </Grid>
        <StoreProductSales startDate={startDate} endDate={endDate} />
      </Box>
    </>
  );
}

export default ProductList;
